import { ClientEventEmitter } from '../../marketing/ClientEventEmitter';
import { ClientEvents } from '../../constants/clientEvents';

type EventFirstBuyData = {
    payment: Payment
};

type Payment = {
    id: number,
    name: string,
    price: number,
    currency: number,
    reward: RewardItem[]
};

type RewardItem = { title: string, count: number };

export class EventFirstBuyHandler {
    public handle(data: EventFirstBuyData): void {
        ClientEventEmitter.fireEvent(ClientEvents.FIRST_BUY, { pmObject: data });
    }
}
